interface HeroProps {
  onJump: (id: string) => void;
}

export default function Hero({ onJump }: HeroProps) {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20retro%20film%20poster%20background%20with%20soft%20peach%20and%20amber%20gradients%2C%20floating%20vintage%20film%20reels%20and%20light%20leaks%2C%20grainy%20analog%20texture%2C%20dramatic%20warm%20lighting%2C%20nostalgic%201990s%20Hong%20Kong%20cinema%20mood%2C%20artistic%20layered%20composition%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=peach-hero-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-16">
        <div className="max-w-4xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/12 border border-background-50/25 text-background-50 text-xs md:text-[13px] font-label backdrop-blur-sm">
            <i className="ri-price-tag-3-line text-accent-400" />
            经典 IP 怀旧 · 两代作品对照
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-[56px] leading-[1.15] font-black text-background-50">
            蜜桃成熟时3D × 1993 原版
            <span className="block text-primary-300 mt-2">一次跨越十八年的对照回望</span>
          </h1>

          <p className="mt-6 max-w-2xl text-background-50/85 text-sm md:text-base leading-relaxed">
            这里把两代《蜜桃成熟时》放在同一张桌子上：原版为什么成为经典？3D 版的女主角是谁、幕后是怎么运作的？又有哪些片段被反复讨论？影评与当年票房到底给出了怎样的答案——一站读完，再慢慢回味。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button
              type="button"
              onClick={() => onJump('compare')}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-label text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-layout-grid-line" />
              查看新旧对比
            </button>
            <button
              type="button"
              onClick={() => onJump('actress')}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 font-label text-sm whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors"
            >
              <i className="ri-user-star-line" />
              女主角是谁
            </button>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-8 gap-y-3 text-background-50/70 text-xs md:text-sm font-label">
            <span className="inline-flex items-center gap-2">
              <i className="ri-film-line text-accent-400" /> 原版 1993 · 李丽珍
            </span>
            <span className="inline-flex items-center gap-2">
              <i className="ri-box-3-line text-accent-400" /> 3D 版 2011 · 吴晴晴
            </span>
            <span className="inline-flex items-center gap-2">
              <i className="ri-star-half-line text-accent-400" /> 影评 · 票房 · 花絮全覆盖
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}